import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { TerminosComponent } from './terminos/terminos.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {

  userSubscription: Subscription = new Subscription();
  name = "";
  userImg= "";
  img="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRlWkkJDRgqwZriGSI4R0ntWMI9Scm31zIQGYJo5ZpeDHSC4MW3"
  title = "Editar perfil";
  user = { 
    id: 0,
    first_name: "",
    last_name: "",
    photo_media_id:{ url: ""},
    email: "",
    email_verified_at: "",
    role_id: 0,
    profile_image: "",
    country: "",
    state: "",
    city: "",
    st_address: "",
    zip: "",
    country_code: "",
    phone_0: "",
    date_of_birth: "",
    gender: "",
    device_token: "",
    fcm_id: "",
    push_notification: "",
    time_zone: "",
    account_status: 0,
    account_delete: 0,
    registration_step: 0,
    session_id: "",
    token: "",
    status: 0,
    deleted_at: "",
    created_at: "",
    updated_at: "",
    country_code_flag: "",
    total_social: 0,
    profile_image_url: "",
    created_atz: "",
    enckey: "",
    doctor: "",
  };

  constructor( private store:Store<AppState>, private service: AuthService, public dialog: MatDialog ) {
    if (this.service.user) {
      this.applyUser(this.service.user);
    }
  }

  ngOnInit() {
    this.userSubscription = this.store.select('user').subscribe(data => {
      if (data && data.data) {
        this.applyUser(data.data);
      }
    });
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

  changeTitle(title){
    this.title = title;
  }

  openTerms(){
    console.log('Opening terms')
    const dialogRef = this.dialog.open(TerminosComponent, {
      width: '1000px',
      height: '780px',
      data: { data: 'filtros' }
    });
  }

  setDefaultAvatar(event) {
    event.target.src = './assets/img/icon_red.png';
  }

  private applyUser(user) {
    this.user = {
      ...this.user,
      ...user
    };
    this.userImg = this.getProfileImageUrl(this.user);
  }

  private getProfileImageUrl(profile): string {
    const candidates = [
      profile && profile.photo_media_id,
      profile && profile.profile_image_url,
      profile && profile.profile_image,
      profile && profile.photo_url,
      profile && profile.avatar_url,
      profile && profile.image_url,
      profile && profile.media,
      profile && profile.photo,
      profile && profile.avatar,
    ];

    for (const candidate of candidates) {
      const imageUrl = this.extractImageUrl(candidate);
      if (imageUrl) return imageUrl;
    }

    return "./assets/img/icon_red.png";
  }

  private extractImageUrl(value): string {
    if (!value) return "";

    if (typeof value === "string") {
      return this.normalizeImageUrl(value);
    }

    if (typeof value !== "object") {
      return "";
    }

    const imageKeys = [
      "url",
      "secure_url",
      "public_url",
      "media_url",
      "file_url",
      "full_url",
      "location",
      "path",
      "src",
    ];

    for (const key of imageKeys) {
      const imageUrl = this.extractImageUrl(value[key]);
      if (imageUrl) return imageUrl;
    }

    return "";
  }

  private normalizeImageUrl(value: string): string {
    const imageUrl = value.trim();
    if (!imageUrl) return "";

    if (
      imageUrl.startsWith("data:image") ||
      imageUrl.startsWith("http://") ||
      imageUrl.startsWith("https://") ||
      imageUrl.startsWith("./") ||
      imageUrl.startsWith("/")
    ) {
      return imageUrl;
    }

    if (imageUrl.startsWith("assets/")) {
      return `./${imageUrl}`;
    }

    return "";
  }
}
